import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import LargePanels from './modules/LP';
import SmallPanels from './modules/SP';
import ComparisonReport from './modules/CR';

import route from './modules/route';

Vue.use(Vuex);

const state = {
  flags: {
    initialPageLoad: true,
    showDebugIds: false,
    showMode: '',
    loadingInitialApiData: false,
  },
  lku: {
    Category: {},
    DataSource: {},
    DataValueType: {},
    Location: {},
    Question: {},
    Response: {},
    Stratification: {},
    StratificationCategory: {},
    Year: {},
  },
  spgsLink: [],
  lpgsLink: [],
  footnotes: [],
  apiErrors: [],
  dataErrors: [],
  dataTypes: {
    AGEADJPREV: {
      dataValuePrefix: '',
      dataValueSuffix: '%',
      dataValueUnit: '%',
      dataValueType: 'Age-adjusted Prevalence',
      decimalPlaces: 1,
      dataRowLabel: 'Age-adjusted Prevalence (%)',
      chartAxisLabel: 'Age-adjusted Prevalence (%)',
      confidenceIntervalLabel: '95% CI',
      sampleSizeLabel: 'Weighted No.',
    },
    PREV: {
      dataValuePrefix: '',
      dataValueSuffix: '%',
      dataValueUnit: '%',
      dataValueType: 'Prevalence',
      decimalPlaces: 1,
      dataRowLabel: 'Prevalence (%)',
      chartAxisLabel: 'Prevalence (%)',
      confidenceIntervalLabel: '95% CI',
      sampleSizeLabel: 'Weighted No.',
    },
  },
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    route,
    LP: LargePanels,
    SP: SmallPanels,
    CR: ComparisonReport,
  },
  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js